import AmountValueObject from './AmountValueObject.js'
import PaymentMethodsValueObject from './PaymentMethodsValueObject.js'
import TaxValueObject from './TaxValueObject.js'

export default class CheckoutValueObjectsFactory {
  static paymentMethodsValueObject = paymentMethods => new PaymentMethodsValueObject(paymentMethods)

  static amountValueObject = ({amountLabelValue, value, currency}) =>
    new AmountValueObject({amountLabelValue, value, currency})

  static taxValueObject = ({type, percentage, amount}) => new TaxValueObject({type, percentage, amount})
}
